<div class="custom-header-financeify d-flex align-items-center justify-content-between flex-wrap gap-3 mt-4"
  [ngClass]="{'ps-0 container': customLogoFinanceify, 'px-3 px-md-5 position-absolute top-0 start-0': !customLogoFinanceify}">
<div class="col-12 col-lg-7 d-flex align-items-center" [ngClass]="{'col-md-12': FunnelFlow.Step != 0, 'col-md-8': FunnelFlow.Step == 0}">
  <div class="col-6 brand-logo-container">
    <img loading="lazy" [src]="pathLogoBrand" width="4023" height="1451" class="img-fluid ms-2 ms-md-0 logo-brand" bh-id="banner-logo-img"
      [ngClass]="{'header-logo-verify-financial-profile': showClassVerify, 'size-logo': customLogoFinanceify}" alt="Brand logo" />
  </div>
  <div *ngIf="FunnelFlow?.PathLogo" class="col-6 cobrand-logo-container">
    <img loading="lazy" [src]="FunnelFlow.PathLogo" class="img-fluid logo" bh-id="banner-cobrand-img">
  </div>
</div>
<div class="col-lg-3 col-md-4 text-center container-action-header-financeify" [ngClass]="{'d-none': FunnelFlow.Step && FunnelFlow.Step!.toString() != '0'}">
  <button (click)="GoToLogin()" class="btn btn-transparent">Log In</button>
  <button (click)="GoToRegisterForm()" class="btn">Sign Up</button>
</div>
</div>
